module.exports = __webpack_public_path__ + "img/no-data.d5ca8302.png";